module.exports = "<div class=\"info-customer\">\n  <div class=\"name\">Nome: <span>{{customer.FirstName}}</span></div>\n  <div class=\"surname\">Cognome: <span>{{customer.LastName}}</span></div>\n  <div class=\"fiscal-code\">Codice Fiscale: <span>{{customer.fiscalCode}}</span></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/alg-billing-frequency/alg-billing-frequency-info-customer/alg-billing-frequency-info-customer.component.html
// module id = ./src/app/components/alg-billing-frequency/alg-billing-frequency-info-customer/alg-billing-frequency-info-customer.component.html
// module chunks = main